import React, { useCallback, useEffect, useState } from 'react'

import useNotification from 'notification';

import DefaultCrudForm from 'components/form/DefaultCrudForm'
import FormContent from 'components/form/FormContent'
import TextInput from 'components/form/input/TextInput'
import Logo from "assets/images/logo2.png"

import { triggerResetEmail } from 'useAuth'

import { Button, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ForgotPasswordPageInter(props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const { email } = props.values
    const { showSuccess } = useNotification()

    const sendEmail = useCallback(async () => {
        if (loading) {
            await triggerResetEmail(email)
            setLoading(false)
            showSuccess("Instruções enviadas para seu email")
            navigate('/login')
        }
    }, [email, loading, navigate, showSuccess])

    useEffect(() => {
        sendEmail()
    }, [sendEmail])

    return (
        <FormContent
            sx={{
                m: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div
                sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    flex: 1,
                    justifyContent: "center",
                    /* align-items: center; */
                    marginTop: "50px",
                }}
            >
                <div style={{ display: 'flex', justifyContent: "center", padding: 10, marginBottom: 10 }}>
                    <img style={{ height: "200px" }} src={Logo} alt="Logo" />
                </div>
                <div style={{ padding: 10, display: 'flex', justifyContent: "center", }}>
                    <TextInput
                        type="email"
                        name="email"
                        label="E-mail"
                        required
                        disabled={loading}
                        sx={{ w: "100%" }}
                    />
                </div>

                <Typography
                    sx={{
                        alignSelf: "center",
                        fontSize: 14,
                        color: "text.disabled",
                        mt: 1,
                        mb: 2
                    }}
                >
                    *Caso não encontre o email, verifique a caixa de spam
                </Typography>

                <div style={{ display: 'flex', justifyContent: "center" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ margin: 8 }}
                        onClick={() => setLoading(true)}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress /> : "Continuar"}
                    </Button>
                </div>
            </div>
        </FormContent>
    )
}

export default function ForgotPasswordPage() {
    const { showWarning } = useNotification()

    const validValues = (values) => {
        console.log('validValues', values)

        if (values.email) {
            let isEmailValid = String(values.email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
            if (!isEmailValid) {
                showWarning("Email inválido")
                return false
            }
        }
        return true
    }

    const saveValues = (values) => {
        console.log('saveValues', values)
    }

    return (<DefaultCrudForm
        saveValues={saveValues}
        validValues={validValues}
        initialValues={{}}
    >
        {(formProps) => {
            return <ForgotPasswordPageInter {...formProps} />
        }}
    </DefaultCrudForm>
    )
}
